import { render, staticRenderFns } from "./census.vue?vue&type=template&id=68101073&scoped=true&"
import script from "./census.vue?vue&type=script&lang=js&"
export * from "./census.vue?vue&type=script&lang=js&"
import style0 from "./census.vue?vue&type=style&index=0&id=68101073&scoped=true&lang=scss&"
import style1 from "./census.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68101073",
  null
  
)

export default component.exports